const a = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" role="presentation" aria-hidden="true"><path d="M8.53 5.78a.75.75 0 0 0-1.06-1.06l-3.5 3.5a.75.75 0 0 0 0 1.06l3.5 3.5a.75.75 0 0 0 1.06-1.06L6.31 9.5H15a3.75 3.75 0 0 1 0 7.5H9.5a.75.75 0 0 0 0 1.5H15A5.25 5.25 0 1 0 15 8H6.31z"/></svg>';
export {
  a as w
};
